import { Check, X } from "lucide-react";

const ChoiceInput = ({ options, value, onChange, disabled }) => {
  const isYesNo =
    options.length === 2 &&
    options.includes("Yes") &&
    options.includes("No");

  return (
    <div className="flex flex-wrap gap-4">
      {options.map(option => {
        const isSelected = value === option;

        // YES / NO CARD STYLE
        if (isYesNo) {
          return (
            <button
              key={option}
              type="button"
              disabled={disabled}
              onClick={() => onChange(option)}
              className={`
                flex items-center gap-5
                px-4 h-[33px] border rounded-[6px]
                text-[16px] font-[500] transition-all
                ${isSelected
                  ? "bg-[#FFF6ED] border-[#FB6514] text-[#FB6514]"
                  : "bg-white border-[#E9EAEB] text-[#494E58]"
                }
                ${disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:border-[#FB6514]"
                }
              `}
            >
              <span>{option}</span>
              {/* ICON – inherits text color */}
              {option === "Yes" && (
                <Check className="w-4 h-4" />
              )}
              {option === "No" && (
                <X className="w-4 h-4" />
              )}
            </button>
          );
        }

        // DEFAULT PILL BUTTON STYLE
        return (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option)}
            className={`
              px-5 h-[16px] rounded-full border text-sm font-medium transition-all
              ${isSelected
                ? "bg-[#FB512D] text-white border-[#FB512D]"
                : "bg-white text-gray-700 border-gray-300 hover:border-[#FB512D] hover:text-[#FB512D]"
              }
              ${disabled
                ? "opacity-50 cursor-not-allowed hover:border-gray-300 hover:text-gray-700"
                : ""
              }
            `}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};

export default ChoiceInput;
